import {
  type ActivatedRouteSnapshot,
  type CanActivateFn,
  Router,
  type RouterStateSnapshot,
  type UrlTree,
} from '@angular/router';
import type { AuthGuardData } from 'keycloak-angular';
import { createAuthGuard } from 'keycloak-angular';
import { inject } from '@angular/core';

const isUnAuthenticated = (
  _route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> =>
  authData.authenticated ? Promise.resolve(inject(Router).parseUrl('/')) : Promise.resolve(true);

export const unAuthGuard = createAuthGuard<CanActivateFn>(isUnAuthenticated);
